import { render, staticRenderFns } from "./year-on-year-analysis.vue?vue&type=template&id=0ab0f77f&"
import script from "./year-on-year-analysis.vue?vue&type=script&lang=js&"
export * from "./year-on-year-analysis.vue?vue&type=script&lang=js&"
import style0 from "./year-on-year-analysis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports